import React from "react";
import logo from "../asset/logo.webp"
import banniere from "../asset/bannierepopup.webp"

const ConsentPopup = ({ onAccept, onDecline }) => {
  return (
    <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl shadow-2xl w-11/12 max-w-lg z-50 overflow-hidden">
      {/* Logo */}
      <div className="flex justify-center items-center py-4 bg-white">
        <img
          src={logo}
          alt="CCPM logo"
          className="w-24 h-auto"
        />
      </div>

      {/* Image */}
      <div>
        <img
          src={banniere} 
          alt="Communauté joyeuse"
          className="w-full h-auto"
        />
      </div>

      {/* Texte */}
      <div className="p-5">
        <h3 className="text-lg text-gray-800 mb-4 text-center font-semibold">
          ✨ <strong>Votre quotidien plus simple et plus joyeux !</strong>
        </h3>
        <p className="text-sm text-gray-600 mb-5 text-center">
          Rejoignez notre communauté et soyez les premiers informés des offres
          exclusives et des réductions jusqu'à <strong>60%</strong> sur les
          Parcs, vacances, cinéma, spectacles…
        </p>

        {/* Options */}
        <div className="text-center space-y-4">
          <label className="flex items-center justify-center text-sm text-gray-800 cursor-pointer">
            <input
              type="checkbox"
              className="w-5 h-5 mr-3 accent-primary"
              onChange={onAccept}
            />
            Oui, je le veux
          </label>
          <label className="flex items-center justify-center text-sm text-gray-800 cursor-pointer">
            <input
              type="checkbox"
              className="w-5 h-5 mr-3 accent-primary"
              onChange={onDecline}
            />
            Non, je préfère passer à côté
          </label>
        </div>
      </div>
    </div>
  );
};

export default ConsentPopup;
